/**
 * <product-recommendations> — progressively upgrades the server-rendered
 * grid (real recommendations if Shopify's engine had data, otherwise the
 * "other products in store" fallback) by fetching the same section through
 * routes.product_recommendations_url, which is the only context where
 * Shopify actually populates the `recommendations` Liquid object.
 * Only swaps content in if the fetch actually returned products, so a
 * failed/empty response never blanks out what's already showing.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    const url = this.dataset.url;
    if (!url) return;

    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshGrid = doc.querySelector('.related-products__grid');
        const currentGrid = this.querySelector('.related-products__grid');

        if (freshGrid && freshGrid.children.length > 0 && currentGrid) {
          currentGrid.innerHTML = freshGrid.innerHTML;
        }
      })
      .catch(() => {
        // Non-fatal: keep whatever was server-rendered.
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);
